import { cva } from 'class-variance-authority';

import { cn } from '@heidi/utils';

export const subVariantClasses = {
  default: cn('border-border bg-surface text-text-primary'),
  subtle: cn('border-border bg-surface-accent text-text-primary'),
  success: cn(
    'border-validation-success-border bg-validation-success-muted text-validation-success'
  ),
  warning: cn(
    'border-validation-warning-border bg-validation-warning-muted text-validation-warning'
  ),
  error: cn(
    'border-validation-destructive-border bg-validation-destructive-muted text-validation-destructive'
  ),
  pro: cn('border-tier-pro-border bg-tier-pro-muted text-tier-pro-text'),
  practice: cn(
    'border-tier-practice-border bg-tier-practice-muted text-tier-practice-text'
  ),
} as const;

export const bannerVariants = cva(
  'relative flex w-full items-center gap-x-4 rounded-lg border p-4',
  {
    variants: {
      subVariant: subVariantClasses,
    },
    defaultVariants: {
      subVariant: 'default',
    },
  }
);
